import { FormArray, FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/framework/components/base.component';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ProductService } from '../product.service';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import Swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss']
})
export class EditProductComponent extends BaseComponent implements OnInit, OnDestroy {
  // @Input() providers;
  @Input() productDetails;
  @Input() producttypes;
  @Input() plantypes;
  @Input() providerService;
  @Input() transactionTypes;
  @Input() carrierCountries;
  @Input() carrierTypes;
  @Input() codeGroups;
  @Input() serviceCountries;
  @Input() responseTypes;
  @Input() allProviders;
  updateProductForm: FormGroup
  providers: any;
  productId: number;
  providerId: any;
  selectedprovider;
  productstatus;
  selectedtransactionType;
  selectedproducttypes;
  selectedplantypes;
  selectedproductService;
  selectedtransactionTypes;
  selectedserviceCountry;
  selectedcarrier;
  selectedcodeGroups;
  selectedserviceCountries;
  selectedresponseTypes;
  selectedpurchaseDiscountType;
  commissionInfo: any = [];
  updatedcommissionInfo: any = [];
  //productDetails: any = [];
  selectedcurrency: any = 'USD';
  selectedstatus;
  selectedwidelyUsed;

  commisionGroup = {}
  commissions: FormArray;
  maxvalue;
  isfix: boolean;



  constructor(private fb: FormBuilder, private router: Router, public dialog: MatDialog, private productService: ProductService, private actRoute: ActivatedRoute, private toastr: ToastrService) {
    super();
  }



  numMask(rawValue: string): RegExp[] {
    const mask = /^(\d*\.)?\d+$/
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['allProviders']) {
      this.allProviders = changes['allProviders'].currentValue;
    }

    if (changes['productDetails']) {
      //
      this.productDetails = changes['productDetails'].currentValue;
      //;
      if (this.productDetails && this.productDetails) {

        //
        var _commissions:any = Array();
        this.commissionInfo = this.productDetails.commissionInfo;
        _commissions = this.productDetails.commissionInfo;
        if(_commissions && _commissions.length == 0){
                // pricelists names
            this.productService.getAllPricelistnametype().subscribe(
              res => {
                let _pricelists: any = res;
                if (_pricelists.httpcode == 200) {
                  //_pricelists.data.forEach(element => {
                  //  element.push({priceListValue:''})
                  //});
                  this.commissionInfo = _pricelists.data;
                 
                  let i = 0;
                  this.commissions.controls = [];
                  this.commissionInfo.forEach(item => {
                    i += 1;
                    this.commisionGroup = {};
                    this.commisionGroup[item.priceListName] = new FormControl('', Validators.required);
                    this.commissions.push(this.fb.group(this.commisionGroup))
                  });
                }
              }
            );
        }else{
            
            let i = 0;
            this.commissions.controls = [];
            this.commissionInfo.forEach(item => {
              i += 1;
              this.commisionGroup = {};
              this.commisionGroup[item.priceListName] = new FormControl(item.priceListValue, Validators.required);
              this.commissions.push(this.fb.group(this.commisionGroup))
            });
        }
        //
        //

        //*************************
        //  create a productData object
        // ≈***********************
        let _productDetails: any = {
          productId: this.productDetails.productdetails.productId,
          providerName: this.productDetails.providerName,
          productName: this.productDetails.productdetails.productName,
          productDropdownName: this.productDetails.productdetails.productDropdownName,
          productDescription: this.productDetails.productdetails.productDescription,
          productType: this.productDetails.productdetails.productType,
          productService: this.productDetails.productdetails.carrierService,
          responseType: this.productDetails.productdetails.responseType,
          serviceCountry: this.productDetails.productdetails.serviceCountry,
          sku: this.productDetails.productdetails.sku,
          exchangeRate: this.productDetails.productdetails.currencyRate,
          codeGroup: this.productDetails.productdetails.codeGroup,
          planType: this.productDetails.productdetails.planType,
          currency: this.productDetails.productdetails.currency,
          carrier: this.productDetails.productdetails.carrier,
          purchaseDiscountType: this.productDetails.productdetails.purchaseDiscountType,
          purchaseDiscount: this.productDetails.productdetails.purchaseDiscount,
          faceValueMinAmt: this.productDetails.productdetails.faceValueMinAmt,
          faceValueMaxAmt: this.productDetails.productdetails.faceValueMaxAmt,
          fee: this.productDetails.productdetails.fee,
          transactionType: this.productDetails.productdetails.transactionType,
          providerId: this.productDetails.productdetails.providerId,
          productStatus: this.productDetails.productdetails.productStatus,
          widelyUsed: this.productDetails.productdetails.widelyUsed,
          cellPaySKU:this.productDetails.productdetails.cellPaySKU,
          cellPayCarrierId:this.productDetails.productdetails.cellPayCarrierId,
        };

        //;
        this.productId = _productDetails.productId;

        this.selectedprovider = _productDetails.providerName;
        this.selectedproducttypes = _productDetails.productType;
        //alert(this.selectedprovider);
        this.selectedplantypes = _productDetails.planType;
        this.selectedproductService = _productDetails.productService;
        this.selectedtransactionTypes = _productDetails.transactionType;
        this.selectedserviceCountry = _productDetails.serviceCountry;
        this.selectedcarrier = _productDetails.carrier;
        this.selectedcodeGroups = _productDetails.codeGroup;
        //this.selectedserviceCountries = _productDetails.;
        this.selectedresponseTypes = _productDetails.responseType;
        this.selectedpurchaseDiscountType = _productDetails.purchaseDiscountType;
        this.selectedstatus = _productDetails.productStatus;
        this.selectedwidelyUsed = _productDetails.widelyUsed;
        


        // Assign values to form
        this.assignValues(_productDetails);

      }
    }

  }



  ngOnInit(): void {
    super.ngOnInit()
    this.initUpdateForm();
    this.commissions = this.updateProductForm.get('commissionInfo') as FormArray;
  }

  initUpdateForm() {
    this.updateProductForm = this.fb.group({
      providerName: ['', Validators.required],
      productName: ['', Validators.required],
      productDropdownName: ['', Validators.required],
      productDescription: ['', Validators.required],
      productType: ['', Validators.required],
      productService: ['', Validators.required],
      responseType: ['', Validators.required],
      serviceCountry: ['', Validators.required],
      sku: ['', Validators.required],
      exchangeRate: ['', Validators.required],
      codeGroup: ['', Validators.required],
      planType: ['', Validators.required],
      currency: ['', Validators.required],
      carrier: ['', Validators.required],
      purchaseDiscountType: ['', Validators.required],
      purchaseDiscount: ['', Validators.required],
      faceValueMinAmt: ['', Validators.required],
      faceValueMaxAmt: ['', Validators.required],
      fee: ['', Validators.required],
      transactionType: ['', Validators.required],
      productStatus: ['', Validators.required],
      widelyUsed: ['', Validators.required],
      commissionInfo: this.fb.array([]),
      cellPaySKU:['',Validators.required],
      cellPayCarrierId:['',Validators.required]
    });
  }


  get f() {
    return this.updateProductForm.controls;
  }


  assignValues(_productDetails) {
    //*************************
    //  assign values to form contrls
    // ≈***********************
    this.updateProductForm.get('providerName').setValue(_productDetails.providerId);
    //this.updateProductForm.get('productId').setValue(_productDetails.productId);
    // need to push provider ID
    //providerId
    if (_productDetails.productType == 'FIX') {
      this.producttypeChange('FIX');
      this.updateProductForm.get('faceValueMinAmt').setValue(_productDetails.faceValueMaxAmt);
      this.isfix = true;
      this.updateProductForm.get('faceValueMaxAmt').setValue(_productDetails.faceValueMaxAmt);
    } else {
      this.updateProductForm.get('faceValueMinAmt').setValue(_productDetails.faceValueMinAmt);
      this.isfix = false;
      this.updateProductForm.get('faceValueMaxAmt').setValue(_productDetails.faceValueMaxAmt);
    }


    this.updateProductForm.get('productName').setValue(_productDetails.productName);
    this.updateProductForm.get('productDropdownName').setValue(_productDetails.productDropdownName);
    this.updateProductForm.get('productDescription').setValue(_productDetails.productDescription);
    this.updateProductForm.get('productType').setValue(_productDetails.productType);
    this.updateProductForm.get('productService').setValue(_productDetails.productService);
    this.updateProductForm.get('responseType').setValue(_productDetails.responseType);
    this.updateProductForm.get('serviceCountry').setValue(_productDetails.serviceCountry);
    this.updateProductForm.get('sku').setValue(_productDetails.sku);
    this.updateProductForm.get('exchangeRate').setValue(_productDetails.exchangeRate);
    this.updateProductForm.get('codeGroup').setValue(_productDetails.codeGroup);
    this.updateProductForm.get('planType').setValue(_productDetails.planType);
    this.updateProductForm.get('currency').setValue(_productDetails.currency);
    this.updateProductForm.get('carrier').setValue(_productDetails.carrier);
    this.updateProductForm.get('purchaseDiscountType').setValue(_productDetails.purchaseDiscountType);
    this.updateProductForm.get('purchaseDiscount').setValue(parseFloat(_productDetails.purchaseDiscount).toFixed(2));
    this.updateProductForm.get('transactionType').setValue(_productDetails.transactionType);
    this.updateProductForm.get('fee').setValue(_productDetails.fee);
    this.updateProductForm.get('productStatus').setValue(_productDetails.productStatus);
    this.updateProductForm.get('widelyUsed').setValue(_productDetails.widelyUsed);
    this.updateProductForm.get('cellPaySKU').setValue(_productDetails.cellPaySKU);
    this.updateProductForm.get('cellPayCarrierId').setValue(_productDetails.cellPayCarrierId);

    this.providerId = _productDetails.providerId;
    this.productId = this.productId;
    // this.updateProductForm.get('commissionPlan1').setValue(_productDetails.commissionPlan1);
    // this.updateProductForm.get('commissionPlan2').setValue(_productDetails.commissionPlan2);
    // this.updateProductForm.get('commissionRate1').setValue(_productDetails.commissionRate1);
    // this.updateProductForm.get('commissionRate2').setValue(_productDetails.commissionRate2);
    //

  }


  onProductDetails() {
    if (!this.updateProductForm.valid) {
      return
    }
    //;

   

    //
    if (this.updateProductForm.get('productType').value == 'FIX') {
      this.maxvalue = this.updateProductForm.get('faceValueMaxAmt').value;
    } else {
      this.maxvalue = this.updateProductForm.get('faceValueMinAmt').value
    }

    let formData: Params = {
      productId: this.productId,
      providerId: this.updateProductForm.get('providerName').value,
      productName: this.updateProductForm.get('productName').value,
      productDropdownName: this.updateProductForm.get('productDropdownName').value,
      sku: this.updateProductForm.get('sku').value,
      productType: this.updateProductForm.get('productType').value,
      provider: this.allProviders.filter(e => e.providerId == this.updateProductForm.get('providerName').value)[0].providerName,
      carrier: this.updateProductForm.get('carrier').value,
      currency: this.updateProductForm.get('currency').value,
      currencyRate: this.updateProductForm.get('exchangeRate').value,
      faceValueMinAmt: this.maxvalue,
      faceValueMaxAmt: this.updateProductForm.get('faceValueMaxAmt').value,
      fee: this.updateProductForm.get('fee').value,
      carrierService: this.updateProductForm.get('productService').value,
      codeGroup: this.updateProductForm.get('codeGroup').value,
      planType: this.updateProductForm.get('planType').value,
      serviceCountry: this.updateProductForm.get('serviceCountry').value,
      productDescription: this.updateProductForm.get('productDescription').value,
      purchaseDiscount: this.updateProductForm.get('purchaseDiscount').value,
      purchaseDiscountType: this.updateProductForm.get('purchaseDiscountType').value,
      responseType: this.updateProductForm.get('responseType').value,
      transactionType: this.updateProductForm.get('transactionType').value,
      widelyUsed: this.updateProductForm.get('widelyUsed').value,
      productStatus: this.updateProductForm.get('productStatus').value,
      commissionInfo: [],
      productHistory: [],
      cellPaySKU:this.updateProductForm.get('cellPaySKU').value,
      cellPayCarrierId:this.updateProductForm.get('cellPayCarrierId').value

    };
    let _updatedcommissionInfo: any = this.commissionInfo;
    _updatedcommissionInfo.forEach((value: any, key: any) => {
      value.priceListValue = this.updateProductForm.get('commissionInfo').value[key][value.priceListName];
      value.priceListValueType = this.updateProductForm.get('purchaseDiscountType').value;
    });
    this.updatedcommissionInfo = _updatedcommissionInfo;
   
    formData['commissionInfo'] = this.updatedcommissionInfo;



   

    this.productService.updateProduct(formData).subscribe(
      res => {
        if (res && res) {
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_111") || res.responseStatus == 'Success'){
            this.router.navigate(['features/products/all-products'])
            this.toastr.success('Product updated successfully', 'Success', {
              timeOut: 3000,
            });        
        } else if (res.errorCodes && res.errorCodes[0] == "TILA_113") { 
            Swal.fire(
              {
                title: res.responseStatus,
                text: res.userMessage,
                icon: 'error',
                timer: 2000
              }
            )
            this.router.navigate(['features/products/all-products'])
          } else {
            Swal.fire(
              {
                title: res.responseStatus,
                text: res.userMessage,
                icon: 'error',
                timer: 2000
              }
            )
            this.router.navigate(['features/products/all-products'])
          }
        }
      }
    );
  }
  onproductChange(e) {
    if (e.value == 'FIX') {
      this.updateProductForm.get('faceValueMinAmt').disable();
    } else {
      this.updateProductForm.get('faceValueMinAmt').enable();
    }
  }
  producttypeChange(value) {
    if (value == 'FIX') {
      this.updateProductForm.get('faceValueMinAmt').disable();
    } else {
      this.updateProductForm.get('faceValueMinAmt').enable();
    }
  }


  onCancel() {
    this.router.navigate(['features/products/all-products'])
    //this.updateProductForm.reset()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }
  checkSubmitDisplayed() {
    return !(this.updateProductForm.valid && !this.updateProductForm.pristine); 
  }
}
